import { createAction, props } from '@ngrx/store';
import { ActionType, PersonNotificationDto } from '@nx-ratenow/shared/models';

// COUNTER
export const setCounter = createAction('[NOTIS] Set counter', props<{ counter: number }>());

export const getCounterNotifications = createAction('[NOTIS] get counter');

// Notifications

export const getNotifications = createAction('[NOTIS] get notifications');

export const setNotifications = createAction(
  '[NOTIS] Set notifications',
  props<{
    personalNotificaitons: PersonNotificationDto[];
    scheludedNotifications: PersonNotificationDto[];
  }>()
);

// ACTION

export const sendAction = createAction(
  '[NOTIS] Sending action',
  props<{
    actionType: ActionType;
    notification: PersonNotificationDto;
  }>()
);
